<template>
    
  <div>

    <page-padding>
      <spinner v-if="showLoader"/>

      
      <!-- search -->
      <ui-input :title="$t('language.search')" :val="search"  @input="(v)=>{search=v}">
        <div slot="icons">
          <ui-chip class="chip" @click.native="showModalPricvacy()" icon="" backgroundColor="#AAAAAA">{{$t('language.privacy')}}</ui-chip>
        </div>
      </ui-input>
      
      <div v-if="!showLoader && !hasChatPersons">{{$t('language.no_chat_persons')}}</div>
      
    
    <infinite-list v-if="hasChatPersons" :list="filteredChatPersons">
     
        <template v-slot:default="chatperson">
          <button-chat-person :item="chatperson.item" :key="chatperson.item.name"></button-chat-person>
      </template>
    </infinite-list>

  </page-padding>

  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../InfiniteList.vue';
import ButtonChatPerson from './ButtonChatPerson.vue';
import Spinner from '../../components/Spinner';
import { eventBus } from '../../services/EventBus.js';
import UiInput from '../UiInput.vue';
import UiChip from '../UiChip.vue';
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export default {
  name: 'list-chat-persons',
  props:{
    group_id:{default:"0"},
  },
  data:function(){
    return {
      showLoader:false,
      search:"",
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonChatPerson,
    Spinner,
    UiInput,
    UiChip,
  },
  methods:{
    showModalPricvacy(){
      modalService.createAlert(i18n.t('language.chat_privacy_message'));
    },
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_chat_persons(){
    
     this.emitLoadStart();

      this.$store.dispatch('get_chat_persons',{}).then((r)=>{
        
        this.tst=r.data;
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'chatpersons','appSettings',
       ]),
       hasChatPersons:function(){
         
         if(this.filteredChatPersons){
           return this.filteredChatPersons ? this.filteredChatPersons.length : false;
         }else{
           return false;
         }
         
       },
       filteredChatPersons() {

        
         // sort on last message date
        var persons=[...this.chatpersons];
        
        // search for searchterm
        persons = persons.filter(item => {

          var found;

          // if searchterm is found in children names
          if(item.children){
            found = item.children.find(item =>{
              // return true if ound
              var childname=item.name ? item.name.toLowerCase() : "";
              return childname.indexOf(this.search.toLowerCase()) > -1
            })
            if(found){ return true;}
          }

          // if searchterm is found in children groups
          if(item.children){
            found = item.children.find(item =>{
              // return true if ound
              var childgroupname=item.group ? item.group.toLowerCase() : "";
              return childgroupname.indexOf(this.search.toLowerCase()) > -1
            })
            if(found){ return true;}
          }
          

          // if search term is found in teach_groups
          if(item.teach_groups){
            found = item.teach_groups.find(grpname =>{
              // return true if ound
              var teachgroupname=grpname ? grpname.toLowerCase() : "";
              return teachgroupname.indexOf(this.search.toLowerCase()) > -1
            })
            if(found){ return true;}
          }


         // at last, if found term in item name return true
         return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })


      

        // sort on date, and on user_type
        return persons.sort( (a ,b ) => {
          var date_a=Date.parse( a.last_chat.datetime.replace(/-/g, '/') ); // make sure date format is using "/" for ios
          var date_b=Date.parse( b.last_chat.datetime.replace(/-/g, '/') ); // make sure date format is using "/" for ios

          if( isNaN(date_a) ){
            date_a=0;
          }

          if( isNaN(date_b) ){
            date_b=0;
          }
          
          if(a.user_type=="watson" || b.user_type=="watson"){
            return 1;
          }

          return (date_b - date_a);

        });
        

      
    },
    
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_chat_persons)
    },
  created:function(){
    this.load_chat_persons();
    eventBus.$on("RELOAD_FROM_PULL",this.load_chat_persons)
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chip{
  cursor:pointer;
}

</style>

